import dynamic from 'next/dynamic'

export default dynamic(() => import('./_index'), { ssr: false })
